import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import TextFieldGroup from './TextFieldGroupNoLabel';
import Dropdown from './Dropdown';
import { setEditFilter } from '../actions/apiSetInfo';
import { updateFilter, deleteFilter } from '../actions/apiFilters';

const activeOptions = ['true', 'false'];

class EditFilterBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter_name: this.props.item.filter_name,
      filter_value: this.props.item.filter_value,
    };
    this.onChange = this.onChange.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onClose() {
    this.props.setEditFilter();
  }

  onBlur(e) {
    const name = e.target.name;
    const { id } = this.props.item;
    let value = e.target.value;
    const errorType = 'updateFilter';
    if (name === 'name') {
      value = value.toLowerCase();
    }
    const data = {
      id,
      [name]: value,
    };

    this.props.updateFilter(id, data, errorType);
  }

  onDelete() {
    this.onClose();
    this.props.deleteFilter(this.props.item.id, 'deleteFilter');
  }

  selectColumns() {
    const columns = this.vehicle_columns();
    const options = columns.map((option) => ({
      value: option.id,
      label: option.name,
    }));
    return options;
  }

  vehicle_columns() {
    const newObj = Object.keys(this.props.vehicle_columns).map(
      (key) => this.props.vehicle_columns[key]
    );
    return _.sortBy(newObj, 'name');
  }

  allFilters() {
    const options = this.props.all_filters.map((option) => ({
      value: option.id,
      label: `${option.filter_name} ( ${option.filter_target} ${option.filter_operator} ${option.filter_value} )`,
    }));
    options.push({ value: 'Create New Filter', label: 'Create New Filter' });
    return options;
  }

  selectData(value) {
	if (this.props.item.data_origin === 'mpi_work_items') {
		const mpiColumns = [
		'vehicle_id', 'work_item_preset_id', 'name', 'description', 'category', 'estimate_type', 'estimate_total',
		'order', 'show_mpi', 'active', 'deleted', 'dealership', 'auto_assign', 'auto_assign_trigger',
		'auto_assign_department_id', 'auto_assign_user_id', 'default_status', 'assign_to_source',
		'profile_dropdown_users', 'automove_counter', 'automove_pending', 'automove_getapproved',
		'automove_approved', 'automove_waiting', 'automove_denied', 'automove_trigger_value',
		'feed_default', 'ro_email_link_approved', 'ro_email_link_declined',
		'ro_email_link_counter_approved', 'ro_email_link_counter_declined', 'ro_status',
		'ro_number', 'ro_files', 'classification', 'assigned', 'recipients', 'recipients_by_uid',
		'recipients_by_date', 'label_requested', 'requested_by_uid', 'requested_date',
		'label_recipients', 'label_pass', 'pass', 'pass_by_uid', 'pass_by_date', 'label_recommend',
		'recommend', 'recommend_by_uid', 'recommend_by_date', 'label_required', 'required',
		'required_by_uid', 'required_by_date', 'label_labor_rate', 'labor_rate', 'labor_rate_by_uid',
		'labor_rate_by_date', 'label_labor_hours', 'labor_hours', 'labor_hours_by_uid',
		'labor_hours_by_date', 'label_labor_total', 'labor_total', 'labor_total_by_uid',
		'labor_total_by_date', 'label_parts', 'parts', 'parts_by_uid', 'parts_by_date',
		'label_parts_total', 'parts_total', 'parts_total_by_uid', 'parts_total_by_date',
		'label_quantity', 'quantity', 'quantity_by_uid', 'quantity_by_date', 'label_estimate_total',
		'estimate_total_by_uid', 'total_by_date', 'label_approved', 'approved', 'approved_by_uid',
		'approved_by_date', 'label_declined', 'declined', 'declined_by_uid', 'declined_by_date',
		'declined_reason', 'label_completed', 'completed_by_uid', 'completed_by_date', 'completed',
		'label_counter', 'counter_by_uid', 'counter_by_date', 'counter', 'lock_pass', 'lock_recommend',
		'lock_required', 'lock_labor_rate', 'lock_labor_hours', 'lock_labor_total', 'lock_parts',
		'lock_parts_total', 'lock_quantity', 'lock_estimate_total', 'lock_approved', 'lock_declined',
		'lock_completed', 'lock_estimate', 'lock_counter', 'dvi_pdf_show', 'dvi_pdf_comments',
		'left_front', 'right_front', 'left_rear', 'right_rear', 'front_actual', 'front_min', 'rear_actual', 'rear_min',
		'left_front_by_uid', 'right_front_by_uid', 'left_rear_by_uid', 'right_rear_by_uid',
		'front_actual_by_uid', 'front_min_by_uid', 'rear_actual_by_uid', 'rear_min_by_uid',
		'left_front_by_date', 'right_front_by_date', 'left_rear_by_date', 'right_rear_by_date',
		'front_actual_by_date', 'front_min_by_date', 'rear_actual_by_date', 'rear_min_by_date',
		'layout_type', 'dvi_description', 'form', 'section', 'custom_header_1', 'custom_header_2',
		'custom_header_3', 'custom_header_4', 'custom_header_5', 'custom_header_6'
		].sort(); // Sort alphabetically
		return mpiColumns.map((col) => ({
		id: col,
		value: col,
		label: col,
		selected: col === value,
		}));
	}
	return this.props.vehicle_columns.map((option) => {
		let selected = false;
		if (option.name === value) {
		selected = true;
		}
		return {
		id: option.id,
		value: option.name || option,
		label: option.name || option,
		selected,
		};
	});
	}

  selectComparison(value) {
    const comparisonArray = [
      { id: 1, name: 'Greater Than', label: 'Greater Than' },
      { id: 2, name: 'Greater or Equal', label: 'Greater or Equal' },
      { id: 3, name: 'Equals', label: 'Equals' },
      { id: 4, name: 'Not Equals', label: 'Not Equals' },
      { id: 5, name: 'Less Than', label: 'Less Than' },
      { id: 6, name: 'Less or Equal', label: 'Less or Equal' },
      { id: 7, name: 'Contains', label: 'Contains' },
    ];
    return comparisonArray.map((option) => ({
      id: option.id,
      value: option.name,
      label: option.label,
      selected: option.name === value,
    }));
  }

  selectDataType(value) {
    const comparisonArray = [
      { id: 1, name: 'number', label: 'Number' },
      { id: 2, name: 'condition', label: 'Condition' },
    ];
    return comparisonArray.map((option) => ({
      id: option.id,
      value: option.name,
      label: option.name,
      selected: option.name === value,
    }));
  }

  selectDataOrigin(value) {
    const comparisonArray = [
      { id: 1, name: 'vehicle', label: 'Vehicle' },
      { id: 2, name: 'vehicle_meta', label: 'Vehicle Meta' },
      { id: 3, name: 'mpi_work_items', label: 'MPI Work Items' },
    ];
    return comparisonArray.map((option) => ({
      id: option.id,
      value: option.name,
      label: option.name,
      selected: option.name === value,
    }));
  }

  render() {
    const { item } = this.props;
    return (
      <div className="card space-top-2">
        <div className="card-header bg-info text-white col-md-12 text-capitalize text-center">
          Edit {item.filter_name}
        </div>
        <ul className="list-group">
          <li className={'list-group-item'}>
            <div className={'row'}>
              <div className={'col-md-6'}>
                <label className={'pad-left-2'}>
                  <strong>Filter Name:</strong>
                </label>
              </div>
              <div className={'col-md-6'}>
                <TextFieldGroup
                  field="filter_name"
                  label="Filter Name"
                  onChange={this.onChange}
                  value={this.state.filter_name}
                  type="text"
                  key={'add_filter_name'}
                  name={'filter_name'}
                />
              </div>
            </div>
          </li>
          <li className={'list-group-item'}>
            <div className={'row'}>
              <div className={'col-md-6'}>
                <label className={'pad-left-2'}>
                  <strong>Target Data:</strong>
                </label>
              </div>
              <div className={'col-md-6'}>
                <Dropdown
                  {...this.props}
                  titleHelper="Select filter_target"
                  title="Select filter_target"
                  list={this.selectData(item.filter_target)}
                  update_type={'all_filter'}
                  value={item.filter_target}
                  all_filter_id={item.id}
                  name={'filter_target'}
                />
              </div>
            </div>
          </li>
          <li className={'list-group-item'}>
            <div className={'row'}>
              <div className={'col-md-6'}>
                <label className={'pad-left-2'}>
                  <strong>FilterType:</strong>
                </label>
              </div>
              <div className={'col-md-6'}>
                <Dropdown
                  {...this.props}
                  titleHelper="Select filter_type"
                  title="Select filter_type"
                  list={this.selectDataType(item.filter_type)}
                  update_type={'all_filter'}
                  value={item.filter_type}
                  all_filter_id={item.id}
                  name={'filter_type'}
                />
              </div>
            </div>
          </li>
          <li className={'list-group-item'}>
            <div className={'row'}>
              <div className={'col-md-6'}>
                <label className={'pad-left-2'}>
                  <strong>DataSource:</strong>
                </label>
              </div>
              <div className={'col-md-6'}>
                <Dropdown
                  {...this.props}
                  titleHelper="Select Work Flow"
                  title="Select Work Flow"
                  list={this.selectDataOrigin(item.data_origin)}
                  update_type={'all_filter'}
                  value={item.data_origin}
                  all_filter_id={item.id}
                  name={'data_origin'}
                />
              </div>
            </div>
          </li>
          <li className={'list-group-item'}>
            <div className={'row'}>
              <div className={'col-md-6'}>
                <label className={'pad-left-2'}>
                  <strong>Operator:</strong>
                </label>
              </div>
              <div className={'col-md-6'}>
                <Dropdown
                  {...this.props}
                  titleHelper="Select filter_operator"
                  title="Select filter_operator"
                  name={'filter_operator'}
                  list={this.selectComparison(item.filter_operator)}
                  update_type={'all_filter'}
                  value={item.filter_operator}
                  all_filter_id={item.id}
                />
              </div>
            </div>
          </li>
          <li className={'list-group-item'}>
            <div className={'row'}>
              <div className={'col-md-6'}>
                <label className={'pad-left-2'}>
                  <strong>Equals:</strong>
                </label>
              </div>
              <div className={'col-md-6'}>
                <TextFieldGroup
                  field="filter_value"
                  name="filter_value"
                  label="Value"
                  onChange={this.onChange}
                  onBlur={this.onBlur}
                  value={this.state.filter_value}
                  type="text"
                  key={'add_filter_value'}
                />
              </div>
            </div>
          </li>
          <li className={'list-group-item'}>
            <div className={'row'}>
              <div className={'col-md-6'} />
              <div className={'col-md-6'}>
                <button className="btn btn-danger" onClick={this.onDelete}>
                  Delete
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

const mappedActions = {
  setEditFilter,
  updateFilter,
  deleteFilter,
};

function mapStateToProps(state) {
  return {
    input_types: state.settings_departments.input_types,
    departments: state.settings_departments.departments,
    all_filters: state.settings_site.all_filters,
    edit_filter: state.settings_site.edit_filter,
    vehicle_columns: state.settings_departments.vehicle_columns,
  };
}
export default connect(mapStateToProps, mappedActions)(EditFilterBox);